<div class="modal-header-modern">
  <div class="modal-header-icon icon-blue">
    <i class="material-icons">attach_file</i>
  </div>
  <div>
    <h4 class="modal-title-modern">Anexar Documento</h4>
    <p class="modal-subtitle-modern">Selecione um arquivo para anexar ao prontuário</p>
  </div>
  <button type="button" class="modal-close-btn" aria-label="Close" (click)="cancelar()">
    <i class="material-icons">close</i>
  </button>
</div>

<div class="modal-body">
  <div class="container-fluid px-0">

    <!-- Drop Zone -->
    <div class="drop-zone"
      [class.drop-zone-active]="dragOver"
      [class.drop-zone-has-file]="arquivoSelecionado"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
      (click)="fileInput.click()">

      <input type="file" #fileInput hidden
        accept=".pdf,.jpg,.jpeg,.png,.gif,.webp,.doc,.docx,.xls,.xlsx,.txt,.csv"
        (change)="onFileSelected($event)" />

      <div *ngIf="!arquivoSelecionado" class="drop-zone-content">
        <i class="material-icons drop-zone-icon">cloud_upload</i>
        <p class="drop-zone-text">Arraste um arquivo aqui ou <span class="drop-zone-link">clique para selecionar</span></p>
        <p class="drop-zone-hint">PDF, imagens, documentos Office, TXT, CSV — até 10MB</p>
      </div>

      <div *ngIf="arquivoSelecionado" class="file-preview" (click)="$event.stopPropagation()">
        <div class="file-preview-icon">
          <i class="material-icons">{{ obterIconeArquivo(arquivoSelecionado.type) }}</i>
        </div>
        <div class="file-preview-info">
          <span class="file-preview-name">{{ arquivoSelecionado.name }}</span>
          <span class="file-preview-size">{{ formatarTamanho(arquivoSelecionado.size) }}</span>
        </div>
        <button type="button" class="file-preview-remove" (click)="removerArquivo(); $event.stopPropagation()">
          <i class="material-icons">close</i>
        </button>
      </div>
    </div>

    <!-- Observação -->
    <div class="row mt-3">
      <div class="col-12">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Observação (opcional)</mat-label>
          <input matInput [(ngModel)]="observacao" maxlength="500" placeholder="Ex: Exame de rotina, receita médica..." />
          <mat-hint align="end">{{ observacao.length }}/500</mat-hint>
        </mat-form-field>
      </div>
    </div>

    <ngx-loading [show]="loading"></ngx-loading>
  </div>
</div>

<div class="modal-footer-modern">
  <button type="button" class="btn-modern btn-modern-outline" (click)="cancelar()">
    <i class="material-icons">close</i> Cancelar
  </button>
  <button type="button" class="btn-modern btn-modern-success" (click)="confirmar()" [disabled]="!arquivoSelecionado || loading">
    <i class="material-icons">cloud_upload</i> Anexar
  </button>
</div>
